module.exports = __webpack_public_path__ + "static/d4Res1-ec1fa34822465b076a6c6abcbf6bc3eb.png";